module.exports = __webpack_public_path__ + "static/media/tolerance-Icon.e2d99df1.svg";